import ProductOptions from './ProductOptions';

export default class VariantHelper {
  constructor(product, variantAvailabilities, $variants, $options) {
    this.product = product;
    this.optionsCount = this.product.options.length;
    this.$variants = $variants;
    this.$options = $options;
    this.productOptions = new ProductOptions(
      this.product,
      variantAvailabilities
    );

    this._bindEvents();
    this._switchVariant(true);
  }

  _bindEvents() {
    this.$options.on('change.variant-helper', () => this._switchVariant());
  }

  _unbindEvents() {
    this.$options.off('change.variant-helper');
  }

  _switchVariant(firstLoad = false) {
    const options = [];
    const product = this.product;
    let variant = null;
    let availableOptions = null;

    this.$options.each((i, option) => {
      options.push(option.value);
    });

    variant = this.productOptions.getVariantOrClosestFromOptions(options);

    if (variant) {
      availableOptions = this.productOptions.getAvailableOptionsFromVariant(
        variant
      );
    } else {
      return;
    }

    this._switchVariantSelect(variant, availableOptions);

    this.$variants.val(variant.id);
    $(window).trigger('product-variant-switch', {
      firstLoad,
      product,
      variant
    });
  }

  _switchVariantSelect(variant, availableOptions) {
    // Iterate over each option type
    for (let i = 0; i < this.product.options.length; i++) {
      // Corresponding select dropdown
      const $select = $(this.$options[i]);
      const $optionEls = $select.find('option');

      // Iterate over each option on dropdown
      $optionEls.each((index, option) => {
        const $option = $(option);
        const value = option.value;

        // Not an available option
        $option
          .prop(
            'disabled',
            !availableOptions[i][value] || !availableOptions[i][value].available
          )
          .prop('selected', false);

        // Dropdown option matches variant option
        if (variant.options[i] === value) {
          $option.prop('disabled', false).prop('selected', true);
        }
      });
    }
  }

  isDefault() {
    if (
      this.product.variants[0].title === 'Default Title' &&
      this.product.variants[0].option1 === 'Default Title'
    ) {
      return true;
    }
  }

  hasSingleOption() {
    return this.optionsCount === 1;
  }

  getSelectedVariant() {
    const options = [];

    this.$options.each((i, option) => {
      options.push(option.value);
    });

    return this.productOptions.getVariantFromOptions(options);
  }

  unload() {
    this._unbindEvents();
  }
}
